import React from 'react';
import { Link } from 'react-router-dom';
const Terms = () => (
  <div className="min-h-screen bg-gray-50 p-6">
    <div className="max-w-3xl mx-auto bg-white rounded-2xl p-8 shadow-sm">
      <Link to="/" className="text-sm mb-6 block" style={{ color: '#B8860B' }}>← Back</Link>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Terms & Conditions</h1>
      <div className="text-gray-600 text-sm space-y-4">
        <p>Last updated: January 2026</p>
        <h2 className="text-lg font-semibold text-gray-900">1. Access & Eligibility</h2>
        <p>All dealers must register and be manually verified by BullionX before accessing the platform.</p>
        <h2 className="text-lg font-semibold text-gray-900">2. Fees</h2>
        <p>A platform fee of 0.1% of the spot value is charged to each party upon a successful match.</p>
        <h2 className="text-lg font-semibold text-gray-900">3. Settlement</h2>
        <p>Settlement is physical. Both parties are responsible for shipping their metals securely and on time.</p>
        <h2 className="text-lg font-semibold text-gray-900">4. Disputes</h2>
        <p>Disputes must be opened within 48 hours of the expected delivery date. BullionX will review within 14 days.</p>
        <h2 className="text-lg font-semibold text-gray-900">5. Governing Law</h2>
        <p>These terms are governed by the laws of the Slovak Republic.</p>
      </div>
    </div>
  </div>
);
export default Terms;
